import Validator from "./Validator";

export default class JsonEntitiesEntityDataCardContentRowsRowComponentsComponentDataPollOptionsOptionValidator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'object',
            empty: false,
            mandatory: false,
            attributes: {
                title: {
                    type: 'string',
                    empty: false,
                    mandatory: false
                },
                option: {
                    type: 'string',
                    empty: false,
                    mandatory: true
                },
                description: {
                    type: 'string',
                    empty: false,
                    mandatory: false
                }
            }
        };
    }
}
